import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

import StaffSalesModule from "./sales/index";
import ActivitiesModule from "./activities/index";
import StaffGrossSalesModule from "./staffGrossSales/index";

const pageConfig = {
  pageName: "Staff Activity",
  configuratorWidth: 375,
  moduleList: [StaffSalesModule, ActivitiesModule, StaffGrossSalesModule]
};

const StaffActivityPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default StaffActivityPage;
